import { render, staticRenderFns } from "./ProntoAtendimentoComponente.vue?vue&type=template&id=da0ac25a&scoped=true"
import script from "./ProntoAtendimentoComponente.vue?vue&type=script&lang=js"
export * from "./ProntoAtendimentoComponente.vue?vue&type=script&lang=js"
import style0 from "./ProntoAtendimentoComponente.vue?vue&type=style&index=0&id=da0ac25a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da0ac25a",
  null
  
)

export default component.exports